import { createContext, useContext, type JSX, type ReactNode } from 'react';

/**
 * LE PORT DU JOURNAL D'AUDIT (`docs/JOURNAL.md`).
 *
 * Meme raison d'etre que les autres ports du socle : l'hote a le SDK, l'ecran
 * du shell ne l'a pas. L'hote branche `sdk.journal.list` ici ; l'ecran cache
 * `/journal` le lit. Les rules n'ouvrent la lecture qu'au proprietaire actif :
 * pour tout autre compte, `lister` est rejete, et c'est la reponse juste.
 */

/** Une ligne du journal telle que l'ecran l'affiche (forme de `AuditEvent`, `@taki/data-model`). */
export interface EvenementJournalVue {
  id: string;
  at: Date;
  category: string;
  action: string;
  actor: { uid: string | null; email: string | null; role: string | null; source: string };
  target: { collection: string; id: string; appId?: string | undefined; door?: string | undefined; label?: string | undefined } | null;
  changes?: { field: string; before?: string | number | boolean | null; after?: string | number | boolean | null }[] | undefined;
  meta?: Record<string, string | number | boolean | null> | undefined;
  outcome: string;
}

/** Les filtres du journal ; `from` inclus, `to` exclu. */
export interface FiltresJournalVue {
  category?: string | undefined;
  actorUid?: string | undefined;
  appId?: string | undefined;
  from?: Date | undefined;
  to?: Date | undefined;
  cursor?: string | null | undefined;
  pageSize?: number | undefined;
}

export interface PageJournalVue {
  events: EvenementJournalVue[];
  next: string | null;
}

export interface JournalPort {
  lister(filtres: FiltresJournalVue): Promise<PageJournalVue>;
}

const Context = createContext<JournalPort | null>(null);

export function JournalProvider({ value, children }: { value: JournalPort | null; children: ReactNode }): JSX.Element {
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

/** Le port, ou `null` quand l'hote n'en fournit pas. */
export function useJournalPort(): JournalPort | null {
  return useContext(Context);
}
